import { render, staticRenderFns } from "./ProdutosCamposPersonalizadosCadastroApp.vue?vue&type=template&id=226cdcd2&scoped=true"
import script from "./ProdutosCamposPersonalizadosCadastroApp.vue?vue&type=script&lang=js"
export * from "./ProdutosCamposPersonalizadosCadastroApp.vue?vue&type=script&lang=js"
import style0 from "./ProdutosCamposPersonalizadosCadastroApp.vue?vue&type=style&index=0&id=226cdcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226cdcd2",
  null
  
)

export default component.exports